import styled from 'styled-components';

const Paragraph = styled.p`
  padding-top: 28px;
  line-height: 1.25em;
  // font-family: Tahoma, Geneva, sans-serif;
  font-family: Arial, Arial, Helvetica, sans-serif;
`;
export default Paragraph;
